export default __webpack_public_path__ + "static/assets/6a1a4e5a0b0b6178c6267a75c065cb9c.png";